import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';
import { ApplicationService } from '../../services/application.service';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { DocumentService } from 'src/app/services/document.service';
import { UtilDto } from 'src/app/data/utilDto';
import { InternshipApplicationDto } from 'src/app/data/ApplicationDto';
import { LogService } from '../../services/log.service';
import { LogDto } from '../../data/logDto';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  constructor(private utilService: UtilService,
    private applicationService: ApplicationService,
    private documentService: DocumentService,
    private logService: LogService,
    private formBuilder: FormBuilder,
    private router: Router
  ) { }

  application: InternshipApplicationDto = {};

  yearList: UtilDto[] = [];
  expectedYearOfGraduationList: UtilDto[] = [];

  currentPage: number = 1 ;

  initForm()
  {
    this.appForm.reset({
      firstName: '',
      middleName: '',
      lastName: '',
      phone: '',
      email: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      postal: '',
      college: '',
      majorConcentration: '',
      yearId: '',
      collegeGpa: '',
      expectedYearOfGraduationId: ''
    })
  }

  ngOnInit(): void {

    this.initForm();

    this.utilService.getSurvey()
      .subscribe( 
        res => 
          {
            if (res.code == 200) {
              this.yearList = res.listado.filter(u => u.type == 'Year');
              this.expectedYearOfGraduationList = res.listado.filter(u => u.type == 'ExpectedYearOfGraduation');
            }
          }
      )
    
  }

  appForm : FormGroup = this.formBuilder.group({
    firstName : [ , [Validators.required]], 
    // middleName : [ , [Validators.required]], 
    middleName : [ , ], 
    lastName : [ , [Validators.required]], 
    phone : [ , [Validators.required]], 
    email : [ , [Validators.required, Validators.email]], 
    addressLine1 : [ , [Validators.required]], 
    // addressLine2 : [ , [Validators.required]], 
    addressLine2 : [ , ], 
    city : [ , [Validators.required]], 
    state : [ , [Validators.required]], 
    postal : [ , [Validators.required]], 
    college : [ , [Validators.required]], 
    majorConcentration : [ , [Validators.required]], 
    yearId : [ , [Validators.required]], 
    collegeGpa : [ , [Validators.required]], 
    expectedYearOfGraduationId : [ , [Validators.required]], 
    // documents : [ , [Validators.required]], 
    // essay : [ , [Validators.required]], 
  });

  isFieldValid( field: string ) {
    return this.appForm.controls[field].errors 
            && this.appForm.controls[field].touched;
  }

  validateStep1(): boolean
  {
    if ( this.appForm.invalid )  {
      this.appForm.markAllAsTouched();
      return false;
    }

    this.application.firstName = this.appForm.value.firstName;
    this.application.middleName = this.appForm.value.middleName;
    this.application.lastName = this.appForm.value.lastName;
    this.application.phone = this.appForm.value.phone;
    this.application.email = this.appForm.value.email;
    this.application.addressLine1 = this.appForm.value.addressLine1;
    this.application.addressLine2 = this.appForm.value.addressLine2;
    this.application.city = this.appForm.value.city;
    this.application.state = this.appForm.value.state;
    this.application.postal = this.appForm.value.postal;
    this.application.college = this.appForm.value.college;
    this.application.majorConcentration = this.appForm.value.majorConcentration;
    this.application.yearId = this.appForm.value.yearId;
    this.application.collegeGpa = this.appForm.value.collegeGpa;
    this.application.expectedYearOfGraduationId = this.appForm.value.expectedYearOfGraduationId;

    return true
  }

  essay: string | null = null;
  essayError: string | null = null;

  validateStep2(): boolean
  {
    if (this.essay == null || this.essay.trim() == '') {
        this.essayError = 'This field is required';
        return false;
    }

    const maxWords = 650;
    const wordCount = this.essay!.trim().split(/\s+/).length;
    console.log('wordCount => ', wordCount);
    if (wordCount > maxWords) {
      this.essayError = `The essay cannot exceed ${maxWords} words. (Current words: ${wordCount})`;
      return false;
    } else {
      this.essayError = null;
    }

    this.application.essay = this.essay;
    return true
  }
  
  deadLineValidation()
  {
    Swal.fire(
      'Info',
      'We apologize, but the deadline for submitting applications has passed. Thank you.',
      'warning'
    );
    return;
  }

  sendApplication()
  {
    if (this.resumeFiles.length == 0) {
      Swal.fire(
        'Required',
        'Resume is required.',
        'warning'
      );
      return;

    }
    if (this.transcriptFiles.length == 0) {
      Swal.fire(
        'Required',
        'Transcript is required.',
        'warning'
      );
      return;
    }

    this.applicationService.saveApplication(this.application)
      .subscribe(
        res => {
          if (res.code == 200) {

            // if (this.resumeFiles.length != 0) {
            this.sendFiles(this.resumeFiles,'Resume',res.objeto.id!);
            // }
            // if (this.transcriptFiles.length != 0) {
            this.sendFiles(this.transcriptFiles,'Transcripts',res.objeto.id!);
            // }

            Swal.fire(
              'Success',
              'Application submitted',
              'success'
            );
            this.initForm();
            this.application = {};
            this.essay = null;
            this.currentPage = 1;
            this.resumeFiles = [];
            this.transcriptFiles = [];
          }
          else if(res.code == 400) {
            this.deadLineValidation()
          }
          else {
            Swal.fire('Error', 'Contact the Administrator.', 'error');
          }
        }
      );

  }


  next(currentPage: number) {

    let request: LogDto = {
      url : this.router.url,
      device : this.utilService.getDeviceDetail(),
      isSuccess : true,
      request : JSON.stringify(this.appForm.value)
    };

    this.logService.saveLog(request).subscribe( res => { });

    if (currentPage == 1) {
      if (!this.validateStep1()) {
        return;
      }  
    }

    if (currentPage == 2) {
      if (!this.validateStep2()) {
        return;
      }  
    }
    
    if (currentPage < 3) {
      this.currentPage = this.currentPage+1;
    }
    
  }

  back(currentPage: number) {
    if (currentPage > 1) {
      this.currentPage = this.currentPage-1;
    }
  }


  transcriptFiles: File[] = [];
  resumeFiles: File[] = [];

  onTranscriptFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.transcriptFiles = Array.from(input.files);
      // console.log(this.transcriptFiles);
    }
  }

  onResumeFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.resumeFiles = Array.from(input.files);
      // console.log(this.resumeFiles);
    }
  }

  sendFiles(files: File[], type: string, applicationId: string): void {
    if (files.length > 0) {

      let formData: FormData = new FormData();
      
      files.forEach(
        file => {
          formData.append('files', file, file.name);
          formData.append('type', type);
          formData.append('applicationId', applicationId);
        }
      );

      // console.log(formData);
      this.documentService.upload(formData)
        .subscribe(response => {
          // console.log('Atachments Files ok');
        }, error => {
          console.error(type,' atachments error', error);
        });
    }
  }

}
